// RatingToolTip.jsx
import React, { useState } from 'react'
import styled from 'styled-components'
import { RatingSummaryTable } from './RatingSummaryTable'

const TooltipWrapper = styled.div`
  position: relative;
  display: inline-block;
`
const TooltipContent = styled.div`
  position: absolute;
  bottom: calc(100% + 8px);
  left: 10%;
  transform: translateX(-12%);
  width: 300px;          /* adjust as needed */
  background-color: rgba(0, 0, 0, 0.9);
  color: white;
  padding: 12px;
  border-radius: 4px;
  text-align: left;
  z-index: 999;
  visibility: ${p => (p.$visible ? 'visible' : 'hidden')};
  opacity:    ${p => (p.$visible ? 1 : 0)};
  transition: opacity 0.2s ease-in-out;
  font-size:  1rem;
  
  &::after {
    content: '';
    position: absolute;
    top: 100%;
    right: 80%;
    transform: translateX(-50%);
    border-width: 6px;
    border-style: solid;
    border-color: rgba(0,0,0,0.85) transparent transparent transparent;
  }
  
  h4 {
    margin: 0 0 8px;
    font-size: 1rem;
    font-weight: bold;
  }
  
  table {
    width: 100%;
    border-collapse: collapse;
  }
  th, td {
    color: white;
    padding: 4px 6px;
    border: 1px solid rgba(255,255,255,0.2);
    font-size: 1rem;
  }
`

export function RatingToolTip({ title, type, children }) {
  const [visible, setVisible] = useState(false)

  return (
    <TooltipWrapper
      onMouseEnter={() => setVisible(true)}
      onMouseLeave={() => setVisible(false)}
    >
      {children}
      <TooltipContent $visible={visible}>
        <h5>{title}</h5>
        <RatingSummaryTable type={type} />
      </TooltipContent>
    </TooltipWrapper>
  )
}
